import { useContext } from "react";
import { AppStateContext, NetworkStateContext } from "../utils/AppStateContext";

export default function useAppState() {
    const appState = useContext(AppStateContext);
    return appState;
}

export function useNetworkState() {
    const networkState = useContext(NetworkStateContext);
    return networkState;
}